module.exports = __webpack_public_path__ + "static/media/ASP TM CHICO.28276564.svg";